// extracted by mini-css-extract-plugin
module.exports = {"review-count":"reviewCount_review-count__aWLH6","review-count-con-based":"reviewCount_review-count-con-based__q8Rpt"};